var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-map',{ref:"mapRef",staticStyle:{"height":"300px"},attrs:{"zoom":_vm.zoom,"center":_vm.center},on:{"click":_vm.onMapClick}},[_c('l-tile-layer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}}),_c('l-marker',{attrs:{"lat-lng":_vm.markerPosition,"icon":_vm.customIcon}},[_vm._v(">")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }